export * from './webStorage';
export * from './localStorage';
export * from './sessionStorage';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/ngx-webstorage/dist/services/index.js
// module id = ../../../../ngx-webstorage/dist/services/index.js
// module chunks = 3